/**
 * MY (马来西亚) 差异化组件映射覆写
 * 命名规则同 diffconfig/config/components.ts：ModulePageSlot（大驼峰）
 */
export default {}
